"use client";
import { DisplayLoadingState, useGenerator } from "@/app/context/GeneratorContext";
import DisplayDefault from "./displayDefault";
import DisplayQueuing from "./displayQueuing";
import DisplayResults from "./displayResults";
import DisplayDelaying from "./displayDelaying";
import DisplayGenerating from "./displayGenerating";
import DisplayErrorJobLimit from "./displayErrorJobLimit";
import DisplayErrorOutOfCredits from "./displayErrorOutOfCredits";
import DisplayErrorGeneric from "./displayErrorGeneric";
import DisplayErrorSensitiveContent from "./displayErrorSensitiveContent";

export default function Display({ translations }: { translations: any }) {
  const { displayLoadingState } = useGenerator();

  const handleDisplay = () => {
    switch (displayLoadingState) {
      case DisplayLoadingState.Default:
        return <DisplayDefault translations={translations} />;
      case DisplayLoadingState.Queueing:
        return <DisplayQueuing translations={translations} />;
      case DisplayLoadingState.Loaded:
        return <DisplayResults />;
      case DisplayLoadingState.Delaying:
        return <DisplayDelaying translations={translations} />;
      case DisplayLoadingState.Generating:
        return <DisplayGenerating translations={translations} />;
      case DisplayLoadingState.ErrorJobLimit:
        return <DisplayErrorJobLimit translations={translations} />;
      case DisplayLoadingState.ErrorOutOfCredits:
        return <DisplayErrorOutOfCredits translations={translations} />;
      case DisplayLoadingState.ErrorGeneric:
        return <DisplayErrorGeneric translations={translations} />;
      case DisplayLoadingState.ErrorSensitiveContent:
        return <DisplayErrorSensitiveContent translations={translations} />;
      default:
        return <DisplayDefault translations={translations} />;
    }
  };
  return <div className="mx-auto flex w-full shadow-lg xl:w-8/12 ">{handleDisplay()}</div>;
}
